import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Grid from '@material-ui/core/Grid'
import Loader from 'components/general/Loader'
import EnergyAPI from 'config/api/EnergyAPI'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import LeadModal from './LeadModal'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import moment from 'moment-timezone'
import { getLeadDisplayName } from 'config/helpers/Helpers'

const useStyles = makeStyles(componentStyles)

function LeadsTable(props) {
    const classes = { ...useStyles() }
    const api = new EnergyAPI()

    const [lead, setLead] = useState(null)
    const [showLeadModal, setShowLeadModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            dataField: 'firstName',
            text: 'Name',
            //sort: true,
            filter: textFilter(),
            filterValue: (cell, row) => `${row.firstName || ''} ${row.lastName || ''}`.trim(),
            formatter: (cell, row) => {
                return (<Box className='hover-text primary-text' onClick={() => openLeadModal(row)}>{getLeadDisplayName(row.firstName, row.lastName)}</Box>)
            },
            headerFormatter: (col, colIndex, components) => {
                return components.filterElement
            }
        },
        {
            dataField: 'product',
            text: 'Product',
            sort: true,
            formatter: (cell, row) => {
                return (<Box>{row.product}</Box>)
            },
        },
        {
            dataField: 'phone',
            text: 'Phone',
            sort: true,
            formatter: (cell, row) => {
                return (<Box>{row.phone}</Box>)
            },
        },
        {
            dataField: 'county',
            text: 'County',
            sort: true,
            formatter: (cell, row) => {
                return (<Box>{row.county}</Box>)
            },
        },
        {
            dataField: 'email',
            text: 'Email',
            sort: true,
            formatter: (cell, row) => {
                return (<Box>{row.email}</Box>)
            },
        },
        {
            dataField: 'isValid',
            text: 'Passed Validation',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.isValid ? 'Yes' : 'No (' + row.invalidReason + ')'}</>
            }
        },
        {
            dataField: 'source',
            text: 'Source',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return (
                    <>
                        {row.source}
                        {row.isReactivation &&
                            <Box
                                component="span"
                                style={{ marginLeft: 6, padding: '1px 6px', borderRadius: 4, fontSize: '0.7rem', backgroundColor: '#e0f2f1', color: '#00695c' }}
                            >
                                Reactivation
                            </Box>
                        }
                    </>
                )
            }
        },
        {
            dataField: 'adSource',
            text: 'Ad Source',
            sort: true,
            formatter: (cell, row) => {
                if (!row.adSource) return <>-</>
                return <>{typeof row.adSource === 'string' ? row.adSource : JSON.stringify(row.adSource)}</>
            }
        },
        {
            dataField: 'createdAt',
            text: 'Created',
            sort: true,
            formatter: (cell, row) => {
                return <>{moment(row.createdAt).format('DD/MM HH:mm')}</>
                //return <>{moment().diff(row.createdAt, 'days')} days ago</>
                //return <>{moment(row.createdAt).fromNow()}</>
            }
        }
    ]

    if (props.title === 'Allocated') {
        let index = 2
        columns[index] = {
            dataField: 'company',
            text: 'Company',
            sort: true,
            formatter: (cell, row) => {
                return <>{row.companyId.toUpperCase() || '-'}</>
            }
        }
        columns.splice(3, 0, {
            dataField: 'leadPrice',
            text: 'Lead Price',
            sort: true,
            formatter: (cell, row) => {
                return <>{row.leadPrice != null ? '€' + row.leadPrice : '-'}</>
            }
        })
    }

    function openLeadModal(lead) {
        setLead(lead)
        setShowLeadModal(true)
    }

    function closeLeadModal() {
        setShowLeadModal(false)
        setLead(null)
    }

    return (
        <Card>
            {!loading ? (
                <>
                    <CardHeader
                        subheader={
                            <>
                                <Box display='flex' style={{justifyContent: 'space-between'}}>
                                    <Box>
                                        <Box
                                            component={Typography}
                                            variant='h2'
                                            marginBottom='0!important'
                                        >
                                            <Box component='span'>{props.title} Leads ({props.leads.length})</Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        }
                        classes={{ root: classes.cardHeaderRoot }}
                    ></CardHeader>
                    
                    <div className='table-container'>
                        <BootstrapTable 
                            keyField='name' 
                            data={ props.leads } 
                            columns={ columns } 
                            filter={ filterFactory() } 
                            pagination={ props.leads.length > 100 ? paginationFactory({
                                sizePerPage: 100,
                                hideSizePerPage: true,
                                showTotal: true,
                                hidePageListOnlyOnePage: true,
                                paginationSize: 5,
                                onPageChange: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
                                paginationTotalRenderer: (from, to, size) => (
                                    <span className='react-bootstrap-table-pagination-total' style={{marginLeft: '0.75rem'}}>
                                        Showing rows {from} to {to} of {size}
                                    </span>
                                ),
                            }) : undefined }
                            noDataIndication={<Box>No pending leads</Box>}
                        />
                    </div>

                    {/*showRequestModal &&
                        <ReturnRequestModal 
                            isOpen={showRequestModal}
                            close={() => closeRequestModal()}
                            request={request}
                            updateRequest={(request) => props.updateRequest(request)}
                            deleteRequest={(request) => props.deleteRequest(request)}
                            showSuccessAlert={(text) => props.showSuccessAlert(text)}
                        />
                    */}
                    {showLeadModal &&
                        <LeadModal 
                            isOpen={showLeadModal}
                            close={() => closeLeadModal()}
                            lead={lead}
                            refreshLeads={() => props.refreshLeads()}
                            showSuccessAlert={(text) => props.showSuccessAlert(text)}
                            companies={props.companies}
                            energyDeliveries={props.energyDeliveries}
                            allSolarCompanies={props.allSolarCompanies}
                            product={props.product}
                            //details={null}
                            //brokers={props.brokers}
                            //claimLead={(lead) => props.claimLead(lead)}
                            updateLead={(lead) => props.updateLead(lead)}
                            //removeLead={(lead, product) => props.removeLead(lead, product)}
                            //product={product}
                            admin={props.admin}
                            site={props.site}
                        />
                    }
                </>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
}

export default LeadsTable